import './styles.scss'

import { AsyncPaginate } from 'react-select-async-paginate'

const AsyncSelect = ({
    value,
    loadOptions,
    onChange,
    isMulti = true,
    placeholder,
    noOptionsMessage = 'Nema više opcija',
    closeMenuOnSelect = true,
    maxLimit,
    label,
    className,
    required,
    loadingMessage = 'Učitavanje podataka...',
    debounceTimeout = 1000,
    cacheUniqs,
    defaultOptions = true,
    isClearable,
    ...props
}) => {
    return (
        <>
            <div className="d-flex">
                {label && <h5 className="mb-2">{label}</h5>}
                {required && <h6 className="required ms-1">*</h6>}
            </div>
            <AsyncPaginate
                value={value}
                defaultOptions={defaultOptions}
                loadOptions={loadOptions}
                onChange={onChange}
                additional={{
                    page: 1,
                }}
                cacheUniqs={cacheUniqs}
                isMulti={isMulti}
                isClearable={isClearable}
                loadingMessage={() => loadingMessage}
                closeMenuOnSelect={closeMenuOnSelect}
                noOptionsMessage={() => noOptionsMessage}
                className={`multi-select-search-async ${className}`}
                debounceTimeout={debounceTimeout}
                placeholder={placeholder}
                formatOptionLabel={(option) => (
                    <div className="competitor-select-option">
                        {option.img ? (
                            <div className="d-flex select-option-with-image-wrapper align-items-center">
                                <img
                                    src={option.img}
                                    alt="image"
                                    className="select-option-img"
                                />
                                <div>
                                    <p>{option.label}</p>
                                    <p className="small-text small-text-grey">
                                        {option.club}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <span>
                                {option.label ? option.label : option.value}
                            </span>
                        )}
                    </div>
                )}
                styles={{
                    multiValue: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: 'transparent',
                        border: '1px solid #A4ACB6',
                        borderRadius: '24px',
                        width: 'max-content',
                    }),
                    multiValueRemove: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: '#A4ACB6',
                        borderRadius: '24px',
                        margin: '3px 3px 3px 0',
                        color: 'white',
                        ':hover': {
                            backgroundColor: '#4C5054',
                        },
                        ':active': {
                            backgroundColor: '#212529',
                        },
                    }),
                    multiValueLabel: (baseStyles, state) => ({
                        ...baseStyles,
                        fontFamily: 'Source Sans Pro',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '20px',
                        letterSpacing: '0.025em',
                        color: '#3B485C',
                    }),
                    menuList: (baseStyles, state) => ({
                        ...baseStyles,
                        padding: '0',
                        borderRadius: '4px',
                    }),
                    option: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: state.isDisabled ? '#F5F5F5' : 'white',
                        fontFamily: 'Source Sans Pro',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '20px',
                        letterSpacing: '0.025em',
                        color: '#4C5054',
                        ':hover': {
                            backgroundColor: '#F5F5F5',
                            cursor: state.isDisabled ? 'default' : 'pointer',
                        },
                    }),
                    indicatorsContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        cursor: 'pointer',
                    }),
                    indicatorSeparator: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: '#96989b',
                    }),
                    valueContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        paddingTop: '8px',
                        paddingBottom: '10px',
                    }),
                    singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        padding: '1px 0 1px 2px',
                    }),
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        ':hover': {
                            borderColor: '#0D284B',
                            boxShadow: '0 0 0 1px #0D284B',
                        },
                        ':focus-within': {
                            borderColor: '#0D284B',
                            boxShadow: '0 0 0 1px #0D284B',
                        },
                        border: '1px solid #96989b',
                    }),
                }}
                {...props}
            />
        </>
    )
}

export default AsyncSelect
